import React from 'react'
import { Link } from 'react-router-dom'

export default function Report({ child }) {    
    return (
        <div className='row' style={{ background: "#e7eaf1", padding: "8px", margin: "0" }}>
            <div className="col-md-2 text-end hide-mobile ms-4">
                <img src={child ? "../denuncia.png" : "denuncia.png"} alt='Linea Color' className='img-fif' />
            </div>
            <div className="col-md-2 col-6">
                <Link to={`/report/pspm`} style={{ color: "white", fontSize: 20 }} className='noLink nav-link'>
                    <button style={{ fontSize: 18 }} className='initialButtons font-size-mobile'>
                        Denuncia a <strong>personas servidoras públicas municipales</strong>
                    </button>
                </Link>
            </div>
            <div className="col-md-2 col-6">
                <Link to={`/report/espm`} style={{ color: "white", fontSize: 20 }} className='noLink nav-link'>
                    <button style={{ fontSize: 18 }} className='initialButtons font-size-mobile'>
                        Denuncia a <strong>elementos de seguridad pública municipal</strong>
                    </button>
                </Link>
            </div>
            <div className="col-md-auto col-4 pad-mobile colorblue text-center">
                <Link to="/declaranet" className='colorblue noLink linko'>
                    <img src={child ? "../declaranet.png" : "declaranet.png"} alt='Linea Color' className='img-fif' />DECLARA<strong>NET</strong> OIC
                </Link>
            </div>
            <div className="col-md-auto col-4 pad-mobile colorblue text-center">
                <Link to="/eticayconducta" className='colorblue noLink linko'>
                    <img src={child ? "../codigoetica.png" : "codigoetica.png"} alt='Linea Color' className='img-fif' />CÓDIGO DE <strong>ÉTICA</strong>
                </Link>
            </div>
            <div className="col-md-auto col-4 pad-mobile colorblue text-center">
                <Link to={`/normativa`} className='noLink nav-link'>
                    <img src={child ? "../normativa.png" : "normativa.png"} alt='Linea Color' className='img-fif' /><strong>NORMATIVA</strong>
                </Link>
            </div>
        </div>
    )
}
